import {
  MaitredActivitySource,
  MaitredActivityType,
  ModelType,
  ModelTypeHelper,
} from '@biteinc/enums';
import { StringHelper } from '@biteinc/helpers';

const backedUpModels = [
  ModelType.Location,
  ModelType.Menu,
  ModelType.Settings,
  ModelType.MenuStructure,
  ModelType.MenuSection,
  ModelType.MenuItem,
  ModelType.ModGroup,
  ModelType.MenuCover,
  ModelType.MenuCoverPromo,
  ModelType.RecommendationRule,
  ModelType.RecommendationVariation,
  ModelType.MenuTiming,
  ModelType.OpenHoursTimetable,
  ModelType.OpenHoursOverride,
  ModelType.Badge,
  ModelType.DictionaryWord,
  ModelType.TaxProfile,
  ModelType.Vendor,
];

app.MaitredActivityCellView = app.CellView.extend({
  className() {
    return `${app.CellView.prototype.className.apply(this, arguments)} maitred-activity`;
  },

  render() {
    app.CellView.prototype.render.apply(this, arguments);

    this._renderAgentProvenance();
    this._renderImpersonationProvenance();

    if (this.model.get('snapshotKey') && app.sessionUser.isBiteSupport() && app.org) {
      const $restoreButton = this.addButtonWithClass(
        'btn-primary',
        this._restoreButtonWasClicked.bind(this),
      );
      $restoreButton.html('Roll Back to Here');
    }

    if (this.model.get('type') === MaitredActivityType.Checkpoint && app.org) {
      const $restoreButton = this.addButtonWithClass(
        'btn-danger',
        this._undoButtonWasClicked.bind(this),
      );
      $restoreButton.html('Undo');
    }

    return this;
  },

  // An MCP activity is attributed to the human whose OAuth grant the agent used, so the cell has
  // to name the agent too — otherwise it is indistinguishable from an action that human took.
  _renderAgentProvenance() {
    if (this.model.get('source') !== MaitredActivitySource.Mcp) {
      return;
    }

    const agentName = this.model.get('mcpClientId') || 'agent';
    const $provenance = $('<div class="mcp-provenance"></div>');
    $provenance.text(`via ${agentName}`);
    this.$('.name').append($provenance);
  },

  // An impersonated activity is attributed to the impersonated user; name the Bite user who acted.
  _renderImpersonationProvenance() {
    const impersonatorUsername = this.model.get('impersonatorUsername');
    if (!impersonatorUsername) {
      return;
    }

    const $provenance = $('<div class="impersonation-provenance"></div>');
    $provenance.text(`impersonated by ${impersonatorUsername}`);
    this.$('.name').append($provenance);
  },

  _restoreButtonWasClicked(event) {
    let promptMessage = 'Rolling back to a backup will replace the following: \n\n';

    backedUpModels.forEach((modelType) => {
      promptMessage += `${StringHelper.toTitleCase(ModelTypeHelper.name(modelType))}\n`;
    });

    promptMessage += '\nSynced data will be lost and restored upon the nest sync.\n';
    promptMessage +=
      '\nPlease type in "Roll Back" to confirm that you want to roll back to this backup.';

    const confirmed = app.promptUserToTypeInConfirmation(promptMessage, 'roll back');
    if (!confirmed) {
      return;
    }

    const $button = $(event.target);
    const reqId = $button.initLoadingButton($button.html(), 'Rolling Back', 'Rolled Back');

    app.QueueHelper.makeRequest('POST', `${this.model.url()}/restore`, null, true, (err) => {
      if (err) {
        $button.loadingDidFinishWithError(reqId);
      } else {
        $button.loadingDidFinishSuccessfully(reqId);
        app.showSavedToastAndReload('Rolled Back!', true);
        window.location.reload();
      }
    });

    return false;
  },

  _undoButtonWasClicked(event) {
    let promptMessage =
      'Undoing an activity will restore locations to the point before the activity was performed.\n';
    promptMessage += 'This action will affect the following: \n\n';

    backedUpModels.forEach((modelType) => {
      promptMessage += `${StringHelper.toTitleCase(ModelTypeHelper.name(modelType))}\n`;
    });

    promptMessage += '\nSynced data will be lost and restored upon the nest sync.\n';
    promptMessage += '\nPlease type in "Undo" to confirm that you want to undo this activity.';

    const confirmed = app.promptUserToTypeInConfirmation(promptMessage, 'undo');
    if (!confirmed) {
      return;
    }

    const $button = $(event.target);
    const reqId = $button.initLoadingButton($button.html(), 'Undoing', 'Undone');

    app.QueueHelper.makeRequest('POST', `${this.model.url()}/undo`, null, true, (err) => {
      if (err) {
        $button.loadingDidFinishWithError(reqId);
      } else {
        $button.loadingDidFinishSuccessfully(reqId);
        app.showSavedToastAndReload('Undone!', true);
        window.location.reload();
      }
    });

    return false;
  },
});
